'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.createDaemon =
    exports.createScheduledDaemon =
    exports.daemon =
    exports.DAEMON_DEFAULTS =
    exports.DaemonMode =
        void 0;
var tslib_1 = require('tslib');
var typed_redux_saga_1 = require('typed-redux-saga');
var errorHandler_1 = require('./errorHandler');
var prepareCall_1 = require('./prepareCall');
var DaemonMode;
(function (DaemonMode) {
    DaemonMode['Sync'] = 'SYNC';
    DaemonMode['Every'] = 'EVERY';
    DaemonMode['Last'] = 'LAST';
    DaemonMode['Schedule'] = 'SCHEDULE';
})((DaemonMode = exports.DaemonMode || (exports.DaemonMode = {})));
exports.DAEMON_DEFAULTS = {
    mode: DaemonMode.Sync,
};
function extractor(func) {
    return function extractorInner(action) {
        var payload, target;
        return (0, tslib_1.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payload = action.payload;
                    target = prepareCall_1.prepareCall.call(this, func);
                    return [
                        5 /*yield**/,
                        (0, tslib_1.__values)(
                            (0, typed_redux_saga_1.apply)(
                                target[0],
                                target[1],
                                Array.isArray(payload) ? payload : [payload]
                            )
                        ),
                    ];
                case 1:
                    return [2 /*return*/, _a.sent()];
            }
        });
    };
}
function daemon(pattern, func) {
    var wrappedFunc, action;
    return (0, tslib_1.__generator)(this, function (_a) {
        switch (_a.label) {
            case 0:
                wrappedFunc = (0, errorHandler_1.errorHandler)(extractor(func));
                _a.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 4];
                return [5 /*yield**/, (0, tslib_1.__values)((0, typed_redux_saga_1.take)(pattern))];
            case 2:
                action = _a.sent();
                return [5 /*yield**/, (0, tslib_1.__values)((0, typed_redux_saga_1.call)(wrappedFunc, action))];
            case 3:
                _a.sent();
                return [3 /*break*/, 1];
            case 4:
                return [2 /*return*/];
        }
    });
}
exports.daemon = daemon;
function createScheduledDaemon(timeout, func) {
    var wrappedFunc;
    return (0, tslib_1.__generator)(this, function (_a) {
        switch (_a.label) {
            case 0:
                wrappedFunc = (0, errorHandler_1.errorHandler)(func);
                _a.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 4];
                return [5 /*yield**/, (0, tslib_1.__values)((0, typed_redux_saga_1.call)(wrappedFunc))];
            case 2:
                _a.sent();
                return [5 /*yield**/, (0, tslib_1.__values)((0, typed_redux_saga_1.delay)(timeout))];
            case 3:
                _a.sent();
                return [3 /*break*/, 1];
            case 4:
                return [2 /*return*/];
        }
    });
}
exports.createScheduledDaemon = createScheduledDaemon;
function createDaemon(pattern, func, config) {
    var task;
    var mode = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, exports.DAEMON_DEFAULTS), config).mode;
    var wrappedFunc = (0, errorHandler_1.errorHandler)(extractor(func));
    if (typeof pattern === 'number' && mode !== DaemonMode.Schedule) {
        throw new Error('Daemon mode is inconsistent with other options');
    }
    function run() {
        return (0, tslib_1.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (task) {
                        return [2 /*return*/];
                    }
                    if (!(mode === DaemonMode.Schedule)) return [3 /*break*/, 2];
                    return [
                        5 /*yield**/,
                        (0, tslib_1.__values)((0, typed_redux_saga_1.spawn)(createScheduledDaemon, pattern, func)),
                    ];
                case 1:
                    task = _a.sent();
                    return [2 /*return*/];
                case 2:
                    if (!(mode === DaemonMode.Every)) return [3 /*break*/, 4];
                    return [
                        5 /*yield**/,
                        (0, tslib_1.__values)(
                            (0, typed_redux_saga_1.spawn)(typed_redux_saga_1.takeEvery, pattern, wrappedFunc)
                        ),
                    ];
                case 3:
                    task = _a.sent();
                    return [2 /*return*/];
                case 4:
                    if (!(mode === DaemonMode.Last)) return [3 /*break*/, 6];
                    return [
                        5 /*yield**/,
                        (0, tslib_1.__values)(
                            (0, typed_redux_saga_1.spawn)(typed_redux_saga_1.takeLatest, pattern, wrappedFunc)
                        ),
                    ];
                case 5:
                    task = _a.sent();
                    return [2 /*return*/];
                case 6:
                    return [5 /*yield**/, (0, tslib_1.__values)((0, typed_redux_saga_1.spawn)(daemon, pattern, func))];
                case 7:
                    task = _a.sent();
                    return [2 /*return*/];
            }
        });
    }
    function destroy() {
        if (!task) {
            return;
        }
        task.cancel();
        task = undefined;
    }
    return {
        run: run,
        destroy: destroy,
    };
}
exports.createDaemon = createDaemon;
